import React from 'react'

export interface Lang {
  language: string,
  changeLanguage:((langCode: string) => void) 
}

const initalContext:Lang = {
  language: '',
  changeLanguage: () => {}
}
export const LanguageProvider = React.createContext(initalContext);